import { render, staticRenderFns } from "./BaseAuthImage.vue?vue&type=template&id=1d9db8cc&"
import script from "./BaseAuthImage.vue?vue&type=script&lang=js&"
export * from "./BaseAuthImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports